// src/hooks/useHistorial.js
import { useState, useEffect } from "react";
import {
  collection, onSnapshot, query, orderBy,
  updateDoc, deleteDoc, doc, serverTimestamp
} from "firebase/firestore";
import { db } from "../firebase";
import toast from "react-hot-toast";

export function useHistorial() {
  const [historial, setHistorial] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const q = query(collection(db, "historial"), orderBy("fecha", "desc"));
    const unsub = onSnapshot(q, snap => {
      setHistorial(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, []);

  const actualizarHistorial = async (id, datos) => {
    try {
      await updateDoc(doc(db, "historial", id), {
        ...datos,
        editadoEn: serverTimestamp(),
      });
      toast.success("✅ Historial actualizado");
    } catch (e) {
      toast.error("Error al actualizar historial");
    }
  };

  const eliminarHistorial = async (id) => {
    try {
      await deleteDoc(doc(db, "historial", id));
      toast.success("🗑 Registro eliminado");
    } catch (e) {
      toast.error("Error al eliminar");
    }
  };

  return { historial, loading, actualizarHistorial, eliminarHistorial };
}
